import { ChatConversationMessage, ChatSocketMessage } from '../models/chat';

export class ChatMessageReceiverService {
    static $inject = ['WebSocket'];

    get onMessageUpdated$() {
        return this._onMessageUpdated$;
    }

    get onNewMessage$() {
        return this._onNewMessage$;
    }

    private _onNewMessage$ = new Rx.Subject<{ meetingId: number; message: ChatConversationMessage }>();
    private _onMessageUpdated$ = new Rx.Subject<{ meetingId: number; message: ChatConversationMessage }>();

    constructor(private socket: WebSocketService) {
        this.socket.on('chat', ({ action, guid, payload, params }: ChatSocketMessage) => {
            const message = { guid, ...payload };
            const meetingId = params.chat;

            if (action === 'message_updated') {
                return this.onMessageUpdated$.onNext({ meetingId, message });
            }

            if (action === 'new_message') {
                return this.onNewMessage$.onNext({ meetingId, message });
            }
        });
    }
}

angular.module('tradersyard').service('ChatMessageReceiverService', ChatMessageReceiverService);
